(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/helpers/team-helpers.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/helpers/team-helpers.js');

'use strict';

const isServer = typeof exports === 'object';
let memberRoles;
let memberStates;
if (isServer) {
  const path = require('path');
  const constants = require(path.join(__dirname, '/..', 'constants.js'));
  memberRoles = constants.memberRoles;
  memberStates = constants.memberStates;
} else {
  memberRoles = svs.arena.constants.memberRoles;
  memberStates = svs.arena.constants.memberRoles;
}

const processTeam = team => {
  var _team$members;
  (_team$members = team.members) === null || _team$members === void 0 || _team$members.forEach(member => {
    member.isLeader = member.memberRole === memberRoles.TEAM_LEADER;
  });
  team.isLeader = team.memberRole === memberRoles.TEAM_LEADER;
  team.isInactive = team.memberState === memberStates.INACTIVE;
  return team;
};
const exportFunctions = {
  processTeam
};
if (isServer) {
  module.exports = exportFunctions;
} else {
  svs.arena.helpers.teamHelpers = exportFunctions;
}

 })(window);